import { render, staticRenderFns } from "./DREMovimentosSideBar.vue?vue&type=template&id=73801146"
import script from "./DREMovimentosSideBar.vue?vue&type=script&lang=js"
export * from "./DREMovimentosSideBar.vue?vue&type=script&lang=js"
import style0 from "./DREMovimentosSideBar.vue?vue&type=style&index=0&id=73801146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports